export async function sendEmail({ to, subject, html }) {
  const res = await fetch(
    "https://vpmcjtzgamhnfyxarqoz.supabase.co/functions/v1/sendEmail",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ to, subject, html }),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Email failed: ${text}`);
  }

  return res.json();
}
